import styled from 'styled-components';

import { IconButton } from '@mui/material';

export const CloseButton = styled(IconButton)`
  display: inline-flex;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;
